<template>
    <!-- Componente para configurar un modelo cargar su cotización y el comparador -->
    <div class="pt-10 pb-10">
        <SeoModelComponent
            :aplics-model="aplicsModel"
            :model-image="modelImage"
            :trim="trimSelected"
            :model-year="modelYear"
            :model-name="modelName"
        />
        <h1 class="font-medium text-xl sm:text-2xl text-center">Configura una versión</h1>
        <!-- Selector de versión mobile -->
        <div class="mt-6 w-10/12 sm:w-7/12 mx-auto lg:hidden">
            <div class="sm:px-2">
                <label class="text-xs font-medium mb-2" for="mark">Versión:</label>
                <select
                    name="mark"
                    id="mark"
                    class="w-full h-10 px-4 text-base appearance-none bg-no-repeat bg-light-brown"
                    :style="{
                        backgroundImage: `url('${url}/images/preowneds/select_arrow.png')`,
                        backgroundSize: '0.6rem',
                        backgroundPosition: '97%',
                    }"
                    v-model="trimId"
                >
                    <option v-for="trim in trims" :key="trim.id" :value="trim.display_name">{{ trim.name }}</option>
                </select>
            </div>
            <div class="mt-12 text-center lg:text-left leading-tight lg:leading-snug">
                <h1 class="font-bold text-2xl sm:text-3xl">
                    {{ trimSelected.name }} <span class="font-normal ml-1">{{ modelYear }}</span>
                </h1>
                <h1 class="font-bold text-2xl sm:text-3xl pl-10 lg:pl-0 pt-2">
                    ${{ formatPrice(trimSelected.price) }}
                    <span class="font-bold text-sm sm:text-base">MXN</span>
                </h1>
                <p class="mt-3 text-sm sm:text-base md:text-lg">"{{ modelMessage }}"</p>
            </div>
        </div>
        <!-- Selector de modelo desktop -->
        <model-versions-desktop
            class="lg:w-11/12 xl:w-10/12 mx-auto hidden lg:block"
            :trims="trims"
            :trim-selected="trimSelected"
            :model-year="modelYear"
            @change-trim="changeTrim"
            :type="type"
        >
        </model-versions-desktop>
        <div class="preview mx-auto mt-12 sm:mt-20 lg:mt-4 w-11/12 xl:w-10/12 lg:flex lg:flex-wrap lg:justify-between">
            <div class="lg:order-2 lg:w-8/12 xl:w-7/12 lg:-mt-4">
                <!-- Vista exterior de modelo en 360 -->
                <div class="carousel flex justify-between lg:justify-center px-3 sm:px-6 lg:px-0">
                    <!-- <button @mousedown="slideToRight()">
                        <i class="border-solid border-black inline-block p-1 mr-1" style="border-width: 0 2px 2px 0; transform: rotate(135deg);"></i>
                    </button> -->
                    <VueProduct360
                        v-if="type === ''"
                        :images="colorSelected.images_360"
                        :image-class="'w-full'"
                        ref="model360"
                        class="cursor-move"
                        v-show="!showLoader"
                    >
                    </VueProduct360>
                    <img v-if="type === '1'" :src="aplicsModel.model_image" alt="Vehiculo" />
                    <div class="lds-dual-ring my-24" v-show="showLoader"></div>
                    <!-- <button @mousedown="slideToLeft()">
                        <i class="border-solid border-black inline-block p-1 mr-1" style="border-width: 0 2px 2px 0; transform: rotate(-45deg);"></i>
                    </button> -->
                </div>
                <div class="mt-8" v-if="type === ''">
                    <img class="w-10 sm:w-12 mx-auto" :src="url + '/images/models/360.png'" alt="360" />
                    <p class="text-xs md:text-sm text-center mt-2 lg:hidden">
                        *Las imágenes son únicamente de referencia, algunas versiones no se encuentran disponibles en
                        México o pueden cambiar según la versión. <br />Consulta nivel de equipamiento y disponibilidad
                        por versión en tu Distribuidor Autorizado Hyundai.
                    </p>
                </div>
                <!-- Selectores de colores -->
                <div class="colors w-11/12 sm:w-6/12 mx-auto mt-4">
                    <!-- Selector de modelo exterior -->
                    <div v-if="type === ''" class="exterior-colors">
                        <div class="color-previews flex items-end">
                            <div
                                class="w-12 md:w-16 cursor-pointer"
                                v-for="(color, key) in trimSelected.colors"
                                :key="color.id"
                            >
                                <img
                                    class="h-4 w-full"
                                    :class="{ 'pl-1': key > 0, 'h-8': key === colorKey }"
                                    :src="color.exterior_thumbnail"
                                    :alt="color.color"
                                    @click="changeColor(key)"
                                />
                            </div>
                        </div>
                        <p class="font-medium text-lg sm:text-xl mt-2">Exterior: {{ colorSelected.color }}</p>
                    </div>
                    <div class="interior-colors mt-4">
                        <!-- Selector de color interior -->
                        <div class="color-previews flex items-end">
                            <div
                                class="w-12 md:w-16 cursor-pointer"
                                v-for="(iColor, key) in colorSelected.interior"
                                :key="key"
                            >
                                <img
                                    class="h-8 opacity-50 w-full"
                                    :class="{ 'pl-1': key > 0, 'opacity-100': key === iColorKey }"
                                    :src="iColor.url"
                                    :alt="iColor.color"
                                    @click="iColorKey = key"
                                />
                            </div>
                        </div>
                        <p class="font-medium text-lg sm:text-xl mt-2">Interior: {{ iColorSelected.color }}</p>
                        <button
                            class="mt-6 w-64 sm:w-72 lg:mt-6 text-sm sm:text-base text-center bg-dark-blue text-white py-3 mx-auto"
                            @click="showInteriorModalStatic"
                            v-if="iColorSelected.static == 1"
                        >
                            Ver Interior
                        </button>
                        <button
                            class="mt-6 w-64 sm:w-72 lg:mt-6 text-sm sm:text-base text-center bg-dark-blue text-white py-3 mx-auto"
                            @click="showInteriorModal"
                            v-else-if="type === ''"
                        >
                            Ver Interior
                        </button>
                        <!-- Modal con visión interior de modelo en 360 -->
                        <modal :width="modalWidth" :height="modalHeight" :adaptive="true" name="interior-modal">
                            <button
                                class="absolute top-0 left-0 mt-1 ml-1 z-10 bg-white border rounded-sm border-gray4 border-solid"
                                @click="toggleIntFullScreen"
                                style="width: 26px; height: 26px"
                            >
                                <svg
                                    v-show="!intFullScreen"
                                    style="padding-left: 2px; padding-top: 2px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"
                                    />
                                </svg>
                                <svg
                                    v-show="intFullScreen"
                                    style="padding-left: 2px; padding-top: 2px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zm10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4z"
                                    />
                                </svg>
                            </button>
                            <button
                                v-show="!intFullScreen"
                                class="absolute top-0 right-0 mt-1 mr-1 z-10 bg-white border rounded-sm border-gray4 border-solid"
                                @click="$modal.hide('interior-modal')"
                                style="width: 26px; height: 26px"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                    <path
                                        d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"
                                    ></path>
                                </svg>
                            </button>
                            <vue-pannellum
                                :mouseZoom="false"
                                :doubleClickZoom="false"
                                :src="`${this.storageUrl}interior_images/interior_image_${iColorSelected.slug}_${trimSelected.id}.webp`"
                            ></vue-pannellum>
                        </modal>
                        <modal
                            :width="modalWidth_static"
                            :height="modalHeight_static"
                            :adaptive="true"
                            name="interior-modal-static"
                        >
                            <button
                                class="absolute top-0 left-0 mt-1 ml-1 z-10 bg-white border rounded-sm border-gray4 border-solid"
                                @click="toggleIntFullScreen(true)"
                                style="width: 26px; height: 26px"
                            >
                                <svg
                                    v-show="!intFullScreen"
                                    style="padding-left: 2px; padding-top: 2px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"
                                    />
                                </svg>
                                <svg
                                    v-show="intFullScreen"
                                    style="padding-left: 2px; padding-top: 2px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zm10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4z"
                                    />
                                </svg>
                            </button>
                            <button
                                v-show="!intFullScreen"
                                class="absolute top-0 right-0 mt-1 mr-1 z-10 bg-white border rounded-sm border-gray4 border-solid"
                                @click="$modal.hide('interior-modal-static')"
                                style="width: 26px; height: 26px"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                    <path
                                        d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"
                                    ></path>
                                </svg>
                            </button>
                            <img
                                :alt="`interior_image_${iColorSelected.slug}_${trimSelected.id}.jpg`"
                                :src="`${this.storageUrl}interior_images/interior_image_${iColorSelected.slug}_${trimSelected.id}.webp`"
                            />
                        </modal>
                    </div>
                    <!-- <a
                        :href="`${url}/${webpage}/modelos/cotizacion/${modelUrl}/${versionUrl}/${modelYear}`"
                        class="w-64 sm:w-72 md:w-80 lg:mt-12 text-sm sm:text-base hyundai-button hidden lg:block"

                        Simula tu crédito
                        class="w-64 sm:w-72 lg:mt-8 text-sm sm:text-base hyundai-button hidden lg:block"

                        Solicitar cotizacion
                        class="w-64 sm:w-72 lg:mt-8 text-sm sm:text-base hyundai-button-gray hidden lg:block"
                    >Solicitar cotización</a> -->
                    <div class="flex flex-col md:flex-row space-y-4 md:space-y-0 mb-1 justify-center">
                        <div class="md:ml-4">
                            <a
                                v-if="!invalidButtons"
                                class="w-64 sm:w-72 lg:mt-8 text-sm sm:text-base hyundai-button hidden lg:block"
                                :href="`/${subData.webpage}/simular-credito?distributor=${subData.webpage}&power-train=${trimSelected.power_train_id}&interior-color=${colorSelected.interior[0].slug}&exterior-color=${colorSelected.slug}${type === '1' && '&type=especial'}`"
                                >Simula tu crédito</a
                            >
                        </div>

                        <div class="md:ml-4">
                            <a
                                v-if="!invalidButtons"
                                class="w-64 sm:w-72 lg:mt-8 text-sm sm:text-base hyundai-button-gray hidden lg:block"
                                :href="`${url}/${webpage}/modelos/formulario-cotizacion/${modelUrl}/${versionUrl}/${modelYear}`"
                            >
                                Solicitar cotización
                            </a>
                        </div>
                    </div>
                </div>
                <p class="text-xs md:text-sm mt-6 text-center hidden lg:block">
                    *Las imágenes son únicamente de referencia, algunas versiones no se encuentran disponibles en México
                    o pueden cambiar según la versión. Consulta nivel de equipamiento y disponibilidad por versión en tu
                    Distribuidor Autorizado Hyundai.
                </p>
            </div>
            <div
                class="specs lg:order-1 w-11/12 sm:w-7/12 lg:w-4/12 mx-auto lg:mx-0 text-base sm:text-lg lg:text-base sm:pl-4 lg:pl-0"
            >
                <p class="mt-3 text-sm sm:text-base md:text-lg lg:text-base hidden lg:block">"{{ modelMessage }}"</p>
                <!-- Specs del modelo -->
                <div class="h-72 sm:h-88 overflow-y-auto mt-10 lg:leading-loose">
                    <p v-for="(spec, key) in trimSpecs" :key="key">
                        <span v-if="spec.value !== 'true'">· {{ spec.name }}: {{ spec.value }}</span>
                        <span v-else>· {{ spec.name }}</span>
                    </p>
                </div>
                <!-- Botones de prueba de manejo y ficha técnica -->
                <div class="mt-16 flex">
                    <a
                        :href="`${url}/${webpage}/modelos/prueba-de-manejo/${modelUrl}/${versionUrl}/${modelYear}`"
                        class="hidden lg:block w-56 text-base text-center text-white bg-dark-blue py-3 relative"
                        >Prueba de manejo
                        <span class="h-4 w-4 animate-ping bg-red absolute rounded-full -right-2 -top-2"></span>
                        <span class="h-4 w-4 bg-red absolute rounded-full -right-2 -top-2"></span>
                    </a>

                    <a
                        target="_blank"
                        :href="trimSelected.data_sheet"
                        class="hidden lg:block w-56 text-base text-center bg-light-brown py-3 ml-4"
                    >
                        <img class="inline h-6" :src="`${url}/images/icons/pdf_icon.png`" alt="pdf" />
                        <p class="ml-3 inline text-sm sm:text-base">Ficha técnica</p>
                    </a>
                </div>
            </div>
            <div class="buttons mt-4 lg:hidden space-y-2">
                <!-- <a
                    :href="`${url}/${webpage}/modelos/cotizacion/${modelUrl}/${versionUrl}/${modelYear}`"
                    class="block w-64 sm:w-72 md:w-80 lg:w-40 text-sm sm:text-base text-center bg-dark-blue text-white py-3 mx-auto"
                >Solicitar cotización</a> -->
                <a
                    v-if="!invalidButtons"
                    class="w-64 sm:w-72 md:w-80 lg:mt-8 text-sm sm:text-base hyundai-button block mx-auto"
                    :href="`/${subData.webpage}/simular-credito?distributor=${subData.webpage}&power-train=${trimSelected.power_train_id}&interior-color=${colorSelected.interior[0].slug}&exterior-color=${colorSelected.slug}${type === '1' && '&type=especial'}`"
                    >Simula tu crédito</a
                >

                <a
                    v-if="!invalidButtons"
                    class="w-64 sm:w-72 md:w-80 lg:mt-8 text-sm sm:text-base hyundai-button-gray block mx-auto"
                    :href="`${url}/${webpage}/modelos/formulario-cotizacion/${modelUrl}/${versionUrl}/${modelYear}`"
                >
                    Solicitar cotización
                </a>

                <a
                    :href="`${url}/${webpage}/modelos/prueba-de-manejo/${modelUrl}/${versionUrl}/${modelYear}`"
                    class="block w-64 sm:w-72 md:w-80 lg:w-40 text-sm sm:text-base text-center bg-dark-blue text-white relative py-3 mx-auto mt-2"
                    >Prueba de manejo
                    <span class="h-4 w-4 animate-ping bg-red absolute rounded-full -right-2 -top-2"></span>
                    <span class="h-4 w-4 bg-red absolute rounded-full -right-2 -top-2"></span>
                </a>
                <a
                    target="_blank"
                    :href="trimSelected.data_sheet"
                    class="block lg:hidden w-64 sm:w-72 md:w-80 text-base text-center bg-light-brown py-3 mx-auto mt-2"
                >
                    <img class="inline h-6" :src="`${url}/images/icons/pdf_icon.png`" alt="pdf" />
                    <p class="ml-3 inline text-sm sm:text-base">Ficha técnica</p>
                </a>
            </div>
        </div>
        <!-- Componente de simulador de crédito de ambas calculadoras -->
        <request-quote-f2
            v-show="showReqQuote"
            :model-id="modelId"
            :version-id="trimSelected.id"
            :model-name="modelName"
            :version-name="trimId.toUpperCase()"
            :model-year="modelYear"
            :version-price="trimSelected.price"
            :click-to-buy="!!trimSelected.click_to_buy"
            :bbva-app-id="trimSelected.bbva_app_id"
            :sub-data="subData"
            :states="states"
            :is-iframe="0"
            :app-env="appEnv"
            :ex-color-selected="colorSelected.slug"
            :int-color-selected="iColorSelected.slug"
            :eikosId="eikosComponent"
            :image-url="colorSelected.images_360[18]"
        />
        <!-- COMPONENTE QUE SOLO MUESTRA LA COTIZACION DE BBVA -->
        <!-- <request-quote-f2-BBVA
            v-show="showReqQuote"
            :model-id="modelId"
            :version-id="trimSelected.id"
            :model-name="modelName"
            :version-name="versionName.toUpperCase()"
            :model-year="modelYear"
            :version-price="trimSelected.price"
            :click-to-buy="!!trimSelected.click_to_buy"
            :bbva-app-id="trimSelected.bbva_app_id"
            :sub-data="subData"
            :states="states"
            :is-iframe="0"
            :app-env="appEnv"
            :ex-color-selected="colorSelected.slug"
            :int-color-selected="iColorSelected.slug"
        /> -->
        <!-- Componente de comparador de versiones -->
        <versions-comparator :versions="trims" :image-model="aplicsModel.model_image"></versions-comparator>
    </div>
</template>

<script>
import VueProduct360 from "@deviznet/vue-product-360";
// import { Pano } from 'vuejs-vr'
import VuePannellum from "vue-pannellum";

import SeoModelComponent from "./seo/SeoModelComponent.vue";
export default {
    components: { VueProduct360, VuePannellum, SeoModelComponent },
    props: [
        "trims",
        "modelId",
        "modelName",
        "modelSlug",
        "modelImage",
        "versionName",
        "modelYear",
        "subData",
        "states",
        "appEnv",
        "aplicsModel",
        "description",
        "title",
        "invalidButtons",
        "type",
        "storageUrl",
    ],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para almacenar el slug del distribuidor
            webpage: $(".webpage").text(),
            // Variable para almacenar el id de la versión seleccionada
            trimId: this.versionName,
            // Variable para almacenar el key del color exterior seleccionado
            colorKey: 0,
            // Variable para almacenar el key del color interior seleccionado
            iColorKey: 0,
            // Variable para determinar si mostrar el lodar
            showLoader: false,
            // Variable para determinar el width del modal
            // para mostrar la visión interior del modelo
            modalWidth: "",
            // Variable para determinar el height del modal
            // para mostrar la visión interior del modelo
            modalHeight: "",
            // Variable para determinar si mostrar la visión interior
            // del modelo en pantalla completa
            intFullScreen: false,
            // Variable para almacenar la última distancia top del modal
            // de la visión interior del modelo
            lastTop: null,
            // Variable para almacenar la última distancia left del modal
            // de la visión interior del modelo
            lastLeft: null,
            // Variable para determinar si mostrar el simulador del cotizador
            showReqQuote: false,

            eikosComponent: null,

            special_trims: ["64494d7dd5a870ba8c8483c5", "66146a07241935175e64258f", "6614873b241935175e64259b"],

            special_models: ["666215eb04d2c075ddede5d4", "666214ed04d2c075ddede5cf"],
            img: new Image(),
            modalWidth_static: "600px",
            modalHeight_static: "300px",
        };
    },
    watch: {
        trimId: function () {
            // se escucha el cambio de version
            this.eikosComponent = this.trimSelected.aplics_eikos_id;

            const title = this.trimSelected.name + " " + this.modelYear;
            document.querySelector("title").innerText = title + " | " + this.modelMessage;
            document.querySelector('meta[name="description"]').setAttribute("content", this.completeDescription);
            document
                .querySelector('link[rel="canonical"]')
                .setAttribute(
                    "href",
                    `${this.url}/${this.webpage}/modelos/prueba-de-manejo/${this.modelUrl}/${this.versionUrl}/${this.modelYear}`,
                );
        },
    },
    methods: {
        // slideToLeft() {
        //     this.$refs.model360.slideToLeft();
        // },
        // slideToRight() {
        //     this.$refs.model360.slideToRight();
        // },
        // Función para dar formato de dinero
        formatPrice(price) {
            return parseInt(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },
        // Función para cambiar la versión seleccionada
        changeTrim(trimId) {
            this.trimId = trimId;
        },
        // Función para cambiar el color exterior
        changeColor(key) {
            this.colorKey = key;
        },
        // Función para mostrar el modal de la visión
        // interior del modelo en 360
        showInteriorModal() {
            this.$modal.show("interior-modal");
        },
        showInteriorModalStatic() {
            this.setModalSize();
            this.$modal.show("interior-modal-static");
        },
        // Función para determinar el tamaño del modal
        // de la visión interior del modelo en 360
        setModalSize() {
            const url = `${this.storageUrl}interior_images/interior_image_${this.iColorSelected.slug}_${this.trimSelected.id}.webp`;
            this.img = new Image();
            this.img.onload = () => {
                let ratio = this.img.width / this.img.height;
                if (window.innerWidth < 640) {
                    this.modalWidth_static = "300px";
                    this.modalHeight_static = "150px";
                } else {
                    this.modalWidth_static = "600px";
                    this.modalHeight_static = "300px";
                }
            };
            if (window.innerWidth < 640) {
                this.modalWidth = "300px";
                this.modalHeight = "200px";
            } else {
                this.modalWidth = "600px";
                this.modalHeight = "400px";
            }
            this.img.src = url;
        },
        // Función para cambiar entre ver el modal de la
        // visión interior del modelo en pantalla completa o no
        toggleIntFullScreen(static_modal = false) {
            this.intFullScreen = !this.intFullScreen;
            if (this.intFullScreen) {
                this.lastTop = $(".vm--modal").css("top");
                this.lastLeft = $(".vm--modal").css("left");
                this.setIntFullScreenType();
            } else {
                if (static_modal) {
                    $(".vm--modal").css("width", this.modalWidth_static);
                    $(".vm--modal").css("height", this.modalHeight_static);
                } else {
                    $(".vm--modal").css("width", this.modalWidth);
                    $(".vm--modal").css("height", this.modalHeight);
                }
                $(".vm--modal").css("top", this.lastTop);
                $(".vm--modal").css("left", this.lastLeft);
            }
        },
        // Función para determinar el tipo de pantalla completa
        // para el modal de visión interior del modelo en 360
        setIntFullScreenType() {
            if (window.innerWidth < window.innerHeight) {
                $(".vm--modal").css("left", "0");
                $(".vm--modal").css("width", "100%");
                let newHeight = ($(".vm--modal").width() * 200) / 300;
                $(".vm--modal").css("height", newHeight.toFixed(2) + "px");
            } else {
                $(".vm--modal").css("top", "0");
                $(".vm--modal").css("left", "0");
                $(".vm--modal").css("width", "100%");
                $(".vm--modal").css("height", "100%");
            }
        },
        // Función para mostar la sección del simulador de crédito
        onClickReqQuote() {
            this.showReqQuote = true;
            this.$eventBus.$emit("showReqQuote");
            this.$nextTick(function () {
                let reqTop = document.getElementById("request-quote").getBoundingClientRect().top;
                $("html, body").animate(
                    {
                        scrollTop: reqTop + $(window).scrollTop() - 20,
                    },
                    1000,
                );
            });
        },
    },
    computed: {
        // Retorna el objeto correspondiente a la versión seleccionada
        trimSelected() {
            this.colorKey = 0;
            this.iColorKey = 0;
            window.history.replaceState(
                { version: this.trimId },
                "",
                `/${this.webpage}/modelos/configura-una-version/${this.modelUrl}/${this.versionUrl}/${this.modelYear}${this.type ? "?type=especial" : ""}`,
            );
            return this.trims.find((trim) => trim.display_name === this.trimId);
        },
        // Retorna el color exterior
        colorSelected() {
            this.iColorKey = 0;
            return this.trimSelected.colors[this.colorKey];
        },

        // Retorna el color interior
        iColorSelected() {
            return this.colorSelected.interior[this.iColorKey];
        },
        // Retorna los specs del modelo seleccionado
        trimSpecs() {
            return this.trimSelected.specs.filter((spec) => spec.value !== "false");
        },
        // Retorna el mensajede acuerdo al modelo correspondiente
        modelMessage() {
            const descriptions = {
                grand_i10_hatchback: "¡Nueva versión a tu medida!",
                grand_i10_sedan: "¡Nueva versión a tu medida!",
                hb20_hatchback: "¡Define el cambio!",
                hb20_sedan: "¡Define el cambio!",
                elantra: "¡Determina quién eres!",
                elantra_hibrido: "¡El balance de la energía!",
                creta: "¡Vive el camino!",
                creta_grand: "¡La grandeza del camino!",
                tucson: "¡Descubre tu poder!",
                tucson_hibrida: "¡El balance de la energía!",
                santa_fe: "¡Donde vamos todos!",
                palisade: "¡La esencia de la creación!",
            };

            return descriptions[this.modelSlug] ?? "La decisión perfecta para cualquiera";
        },
        modelMessageDescription() {
            const descriptions = {
                grand_i10_hatchback: "¡Evolución a tu medidad!",
                grand_i10_sedan: "¡Evolución a tu medidad!",
                hb20_hatchback: "¡Tú defines el cambio!",
                hb20_sedan: "¡Tú defines el cambio!",
                elantra: "¡Tú determinas quién eres!",
                elantra_hibrido: "¡El balance de la energía!",
                creta: "La camioneta que estabas esperando ¡Vive el camino!",
                creta_grand: "La camioneta que estabas esperando ¡La grandeza del camino!",
                tucson: "¡Descubriendo tu poder!",
                tucson_hibrida: "¡El balance de la energía!",
                santa_fe: "¡Donde nos vamos todos!",
                palisade: "¡La esencia de la creación!",
            };

            return descriptions[this.modelSlug] ?? "La decisión perfecta para cualquiera";
        },
        // Retorna la url del modelo
        modelUrl() {
            return this.modelSlug.replaceAll("_", "-");
        },
        // Retorna la url de la versión
        versionUrl() {
            return this.trimId.replaceAll(" ", "-");
        },
        eikosSelected() {
            this.eikosComponent = this.trimSelected.aplics_eikos_id;
            return this.trimSelected.aplics_eikos_id;
        },
        completeDescription() {
            let description = "Hyundai " + this.trimSelected.name + " | ";
            switch (this.modelSlug) {
                case "grand_i10_hatchback":
                case "grand_i10_sedan":
                case "hb20_hatchback":
                case "hb20_sedan":
                case "elantra":
                    description += "Automóvil " + this.aplicsModel.category.name;
                    break;
                case "elantra_hibrido":
                    description += "Automóvil Híbrido";
                    break;
                case "tucson_hibrida":
                    description += "SUV Híbrida";
                    break;
                default:
                    description += this.aplicsModel.category.name;
                    break;
            }
            const motorSpec = this.trimSelected.specs.find((e) => e.name == "Motor");
            if (motorSpec && motorSpec != undefined) {
                description += " Motor " + motorSpec?.value + ", ";
            }

            const transmisionSpec = this.trimSelected.specs.find(
                (e) => e.name == "Tipo de transmisión / No. de velocidades",
            );
            if (transmisionSpec && transmisionSpec != undefined) {
                description += "Transimisión ";
                if (transmisionSpec?.value.includes("/")) {
                    const transmisionValue = transmisionSpec?.value.split(" / ");
                    description += transmisionValue[0] + " a " + transmisionValue[1] + " velocidades, ";
                } else {
                    description += transmisionSpec?.value + ", ";
                }
            }

            const cilinderSpec = this.trimSelected.specs.find((e) => e.name == "No. de cilindros / disposición");
            if (cilinderSpec && cilinderSpec != undefined) {
                description += cilinderSpec.value + " cilindros. ";
            }

            return (description += this.modelMessageDescription);
        },
        selectInteriorImage() {
            if (this.special_models.find((e) => e == this.aplicsModel.model_id) != undefined) {
                return true;
            } else if (this.special_trims.find((e) => e == this.trimSelected.power_train_id) != undefined) {
                return true;
            }
            return false;
        },
    },
    created() {
        this.eikosSelected;
        this.setModalSize();
    },
    mounted() {
        window.addEventListener("orientationchange", this.setIntFullScreenType());
        document.querySelector('meta[name="description"]').setAttribute("content", this.description);
        document.querySelector("title").innerText = this.title;
        this.completeDescription;
    },
    destroyed() {
        window.removeEventListener("orientationchange", this.setIntFullScreenType());
    },
};
</script>

<style></style>
